import React, { useEffect, useState, useMemo } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Validator } from "../widgets";
import { uuid, validateCollections, verifyObjectProperties } from "../../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import { getRateTypesList, saveRateSchedules } from "../../actions/rate-schedule";
import { RATE_TYPE_LISTS } from "../../constants";
import { getUserId } from '../../helpers/session';

const RateScheduleModal = (props) => {
  const dispatch = useDispatch()
  const {
    show,
    handleClose,
    setRateList,
    isEditRateModal,
    editedData,
    farmId,
    rateList } = props;
  const [rateConfig, setRateConfig] = useState({
    rateId: null,
    rateName: "",
    rateType: "",
    rateTypeLabel: "",
    rateValue: 0,
    surchargeEnabled: 'No',
    surchargeEnabledLabel: 'No',
    surchargeRateType: '',
    surchargeRateTypeLabel: '',
    surchargeRate: 0,
    visible: true,
    surChargePercentValue: 0,
    ownBedRate: 0
  })

  const [isSubmited, setIsSubmited] = useState(false)
  const [errors, setErrors] = useState({});
  const [validations, setValidatons] = useState('');
  const rateTypes = useSelector((state) => state.rateSchedule.rateTypeList);
  const [rateOptions, setRateOptions] = useState([])
  const [surChargeRateOptions, setsurChargeRateOptions] = useState([]);

  useEffect(() => {
    dispatch(getRateTypesList())
  }, [])

  useEffect(() => {
    if (rateTypes && rateTypes.length > 0) {
      const rateTypeData = rateTypes.filter((e) => e.rate_type === RATE_TYPE_LISTS.RATE_TYPE).map((type) => {
        return {
          label: type.rate_type_name,
          value: type.rate_type_uuid,
        }
      })

      const surChargeTypeData = rateTypes.filter((e) => e.rate_type === RATE_TYPE_LISTS.SURCHARGE_TYPE).map((type) => {
        return {
          label: type.rate_type_name,
          value: type.rate_type_uuid,
        }
      })

      setRateOptions(rateTypeData)
      setsurChargeRateOptions(surChargeTypeData)
    }
  }, [rateTypes])

  // const rateOptions = [{ label: 'Load', value: 'Load' }, { label: 'Ton', value: 'Ton' }, { label: 'Mile', value: 'Mile' }]
  const surChargeOptions = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]
  // const surChargeRateOptions = [{ label: 'Mile', value: 'Mile' }, { label: 'Ton', value: 'Ton' }, { label: 'Load', value: 'Load' }]

  const preparedEditedData = {
    rateId: verifyObjectProperties(editedData, "rate_uuid"),
    rateName: verifyObjectProperties(editedData, "rate_name"),
    rateType: verifyObjectProperties(editedData, "rate_type_uuid"),
    rateValue: verifyObjectProperties(editedData, "rate_value", 0),
    surchargeEnabled: verifyObjectProperties(editedData, "surcharge_applicable", "Yes"),
    surchargeRateType: verifyObjectProperties(editedData, "surcharge_type_uuid"),
    surchargeRate: verifyObjectProperties(editedData, "surcharge_value", 0),
    visible: verifyObjectProperties(editedData, "rate_schedule_applicable", false),
    surChargePercentValue: verifyObjectProperties(editedData, "additional_surcharge_percent", false),
    ownBedRate: verifyObjectProperties(editedData, "own_bed_rate_value", false),
  }

  const validateRateConfig = (config, field = null) => {
    const newErrors = { ...errors };
    const fieldsToValidate = field ? [field] : Object.keys(config);

    const validationRules = {
      rateName: {
        required: true,
        message: "Rate Name is required.",
        condition: (value) => !!value,
      },
      rateType: {
        required: true,
        message: "Rate Type is required.",
        condition: (value) => !!value,
      },
      rateValue: {
        required: true,
        message: "Rate Value must be greater than 0.",
        condition: (value) => {
          const num = parseFloat(value);
          return !isNaN(num) && num > 0;
        },
      },
      surchargeRateType: {
        required: config.surchargeEnabled === "Yes",
        message: "Surcharge Rate Type is required.",
        condition: (value) => !!value,
      },
      surchargeRate: {
        required: config.surchargeEnabled === "Yes",
        message: "Surcharge Rate must be greater than 0.",
        condition: (value) => !isNaN(parseFloat(value)) && parseFloat(value) > 0,
      },
    };

    fieldsToValidate.forEach((key) => {
      const rule = validationRules[key];
      if (rule) {
        if (rule.required && !rule.condition(config[key])) {
          newErrors[key] = rule.message;
        } else if (newErrors[key]) {
          delete newErrors[key];
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTypeChange = (e, fieldName) => {
    const value = e && (e !== null) && e.value ? e.value : '';
    const label = e && (e !== null) && e.label ? e.label : '';

    if (value !== null) {
      setRateConfig((prevState) => ({
        ...prevState,
        [fieldName]: value ? value : '',
        [`${fieldName}Label`]: label,
      }));
    } else {
      setRateConfig((prevState) => ({
        ...prevState,
        [fieldName]: '',
        [`${fieldName}Label`]: '',
      }));
    }

    if (isSubmited) {
      setValidatons(fieldName)
    }
  };

  const handleInputChange = (e, key, type = "string") => {
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (type === "number") {
      value = value !== "" ? value : 0;
    } else if (type === "boolean") {
      value = !!value;
    }

    setRateConfig((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (isSubmited) {
      setValidatons(key)
    }
  };

  const handleCloseFun = () => {
    setIsSubmited(false)
    handleClose()
  }

  useMemo(() => {
    if (validations) {
      validateRateConfig(rateConfig, validations);
      setValidatons('')
    }
  }, [validations])

  const handleSubmit = () => {
    setIsSubmited(true)
    const validation = validateRateConfig(rateConfig);
    if (!validation) {
      return;
    }

    let data = [];
    if (rateConfig) {
      const object = {
        rate_uuid: isEditRateModal ? rateConfig.rateId : uuid(),
        rate_name: rateConfig.rateName,
        rate_type_uuid: rateConfig.rateType,
        rate_value: parseFloat(rateConfig.rateValue),
        surcharge_applicable: (rateConfig.surchargeEnabled && rateConfig.surchargeEnabled === "Yes") ? 1 : 0,
        surcharge_type_uuid: rateConfig.surchargeRateType ? rateConfig.surchargeRateType : null,
        surcharge_value: parseFloat(rateConfig.surchargeRate),
        rate_schedule_applicable: rateConfig.visible ? 1 : 0,
        additional_surcharge_percent: parseFloat(rateConfig.surChargePercentValue),
        own_bed_rate_value: parseFloat(rateConfig.ownBedRate)
      }
      data.push(object)
    }

    if (isEditRateModal) {
      let updatedRateList = validateCollections(rateList) && rateList.filter(it => it.rate_uuid !== preparedEditedData.rateId);
      updatedRateList = updatedRateList.map(it => {
        return {
          ...it,
          surcharge_applicable: it.surcharge_applicable ? 1 : 0,
          rate_schedule_applicable: it.rate_schedule_applicable ? 1 : 0
        }
      })
      setRateList(() => {
        const dataList = [...updatedRateList, ...data]
        return dataList.sort((prev, next) => prev.rate_name.localeCompare(next.rate_name));
      });
    } else {
      let dataList = [...rateList, ...data].sort((prev, next) => prev.rate_name.localeCompare(next.rate_name));
      dataList = dataList.map(it => {
        return {
          ...it,
          surcharge_applicable: it.surcharge_applicable ? 1 : 0,
          rate_schedule_applicable: it.rate_schedule_applicable ? 1 : 0
        }
      })

      setRateList(dataList);
    }

    const params = {
      farm_uuid: farmId,
      user_id: getUserId(),
      rate_schedule: [...data]
    }

    dispatch(saveRateSchedules(params))
    handleClose();
  };

  useEffect(() => {
    if (isEditRateModal) {
      let data = preparedEditedData;
      data.surchargeEnabled = (data.surchargeEnabled === 1) ? "Yes" : "No";
      setRateConfig({ ...data });
    }
  }, [isEditRateModal]);

  return (
    <>
      <Modal show={show} onHide={handleClose} className="modal-form rate_schedule_modal" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Rate Schedules </Modal.Title>

          <Col sm={6} md={6} lg={6} className="mt-2">
            <Form.Group className="mb-0">
              <Form.Check
                type="switch"
                id="activeInactiveToggle"
                label={rateConfig.visible ? "Active" : "Inactive"}
                checked={rateConfig.visible}
                onChange={(e) => handleInputChange(e, "visible", "boolean")}
                isInvalid={!!errors.visible}
              />
              <Form.Control.Feedback type="invalid">
                {errors.visible}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Modal.Header>
        <Modal.Body>
          <Row className="m-0">
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label> Name <Validator.Mand /></Form.Label>
                <Form.Control
                  type="text"
                  id="rateName"
                  placeholder="Enter Rate Schedule Name"
                  value={rateConfig.rateName}
                  onChange={(e) => handleInputChange(e, "rateName", "text")}
                  isInvalid={!!errors.rateName}
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.rateName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="rateType">Rate Type <Validator.Mand /> </Form.Label>
                <Form.Select
                  id="rateType"
                  placeholder="Select Rate Type"
                  name="rateType"
                  onChange={(e) => handleTypeChange(e, 'rateType')}
                  value={rateConfig.rateType || ''}
                  options={rateOptions}
                  className={`${((errors) && errors.rateType) ? 'is-invalid' : ''}`}
                  required
                />

                {((errors) && errors.rateType) ?
                  <small className="form-text invalid-feedback">{errors.rateType}</small> : null}
              </Form.Group>
            </Col>
            {rateConfig.rateType ? <>
              <Col sm={6} md={6} lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="rateValue"> Rate per {rateConfig.rateTypeLabel} USD ($)
                    <small className="error-mand ml-1">*</small></Form.Label>
                  <Form.Control
                    id="rateValue"
                    value={rateConfig.rateValue || ''}
                    type="number"
                    onChange={(e) => handleInputChange(e, 'rateValue', 'number')}
                    placeholder={`Enter Rate per ${rateConfig.rateTypeLabel}`}
                    isInvalid={!!errors.rateValue}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.rateValue}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </> : null}
          </Row>
          <Row className="m-0">
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="ownBedRate">Own Bed Rate USD ($)</Form.Label>
                <Form.Control
                  id="ownBedRate"
                  type="number"
                  placeholder={`Enter Own Bed Rate`}
                  value={rateConfig.ownBedRate || ''}
                  onChange={(e) => handleInputChange(e, 'ownBedRate', 'number')}
                />
              </Form.Group>
            </Col>

            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="surChargePercentValue">Additional Surcharge (%) </Form.Label>
                <Form.Control
                  id="surChargePercentValue"
                  type="number"
                  min={0.01}
                  max={100}
                  placeholder={`Enter Additional Surcharge (%)`}
                  value={rateConfig.surChargePercentValue || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (parseFloat(value) >= 0.001 && parseFloat(value) <= 100)) {
                      handleInputChange(e, 'surChargePercentValue', 'number');
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="m-0">
            <Col sm={6} md={6} lg={6}>
              <Form.Group className="d-flex align-items-center">
                <h6 className="mr-3 mb-0">Custom Surcharge</h6>
                <div className="d-flex">
                  {surChargeOptions.map((option) => (
                    <Form.Check
                      key={option.value}
                      type="radio"
                      id={`surchargeEnabled-${option.value}`}
                      name="surchargeEnabled"
                      className="mx-2"
                      value={option.value}
                      label={option.label}
                      checked={rateConfig.surchargeEnabled === option.value}
                      onChange={(e) => handleTypeChange(e.target, 'surchargeEnabled')}
                    />
                  ))}
                </div>
              </Form.Group>
            </Col>
          </Row>

          {(rateConfig.surchargeEnabled === 'Yes') ? <Row className="m-0">
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="surchargeRateType">Surcharge Rate Type <Validator.Mand /> </Form.Label>
                <Form.Select
                  id="surchargeRateType"
                  placeholder="Select Surcharge Type"
                  name="surchargeRateType"
                  onChange={(e) => handleTypeChange(e, 'surchargeRateType')}
                  value={rateConfig.surchargeRateType || ''}
                  options={surChargeRateOptions}
                  className={`${((errors) && errors.surchargeRateType) ? 'is-invalid' : ''}`}
                  required
                />
                {((errors) && errors.surchargeRateType) ?
                  <small className="form-text invalid-feedback">{errors.surchargeRateType}</small> : null}
              </Form.Group>
            </Col>
            {rateConfig.surchargeRateType ? <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="surchargeRate">Surcharge per {rateConfig.surchargeRateTypeLabel} USD ($) <Validator.Mand /> </Form.Label>
                <Form.Control
                  id="surchargeRate"
                  type="number"
                  min={0.001}
                  placeholder={`Enter Surcharge per ${rateConfig.surchargeRateTypeLabel}`}
                  value={rateConfig.surchargeRate || ''}
                  onChange={(e) => handleInputChange(e, 'surchargeRate', 'number')}
                  isInvalid={!!errors.surchargeRate}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.surchargeRate}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> : null}
          </Row> : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseFun()}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => handleSubmit()}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RateScheduleModal;
